import React from 'react'
import SchoolLookUpLayout from './SchoolLookUpLayout'
import { useSchoolLookUp } from './hooks/useSchoolLookUp'
import { SchoolLookUpSiteData } from 'types'

export interface SchoolLookUpProps {
  disabled?: boolean
  fireOnLoad?: boolean
  onSelection: (data: SchoolLookUpSiteData) => void
  siteData: SchoolLookUpSiteData
}

const SchoolLookUp: React.FC<SchoolLookUpProps> = ({
  disabled = false,
  fireOnLoad = true,
  siteData,
  onSelection,
}) => {
  const {
    getNetSuiteCustomerObject,
    getNetsuiteCustomerId,
    handleFieldChange,
    handleLoadSchoolsData,
    handleLoadStateData,
    handleSchoolNameChange,
    handleSchoolSelect,
    hasRegionData,
    selectCitiesEndpoint,
    selectSchoolsEndpoint,
    selectedSiteData,
  } = useSchoolLookUp(siteData, onSelection, fireOnLoad)

  return (
    <SchoolLookUpLayout
      city={selectedSiteData.city}
      country={selectedSiteData.country}
      disabled={disabled}
      hasRegionData={hasRegionData}
      netsuiteCustomerId={selectedSiteData.netsuiteCustomerId}
      organizationName={selectedSiteData.organizationName}
      region={selectedSiteData.region}
      onFieldChange={handleFieldChange}
      onLoadStateData={handleLoadStateData}
      onLoadSchoolsData={handleLoadSchoolsData}
      onSchoolNameChange={handleSchoolNameChange}
      onSchoolSelect={handleSchoolSelect}
      onSelectCitiesEndpoint={selectCitiesEndpoint}
      onSelectSchoolsEndpoint={selectSchoolsEndpoint}
      getNetSuiteCustomerObject={getNetSuiteCustomerObject}
      getNetsuiteCustomerId={getNetsuiteCustomerId}
    />
  )
}

export default SchoolLookUp
